import styled from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { getFont } from '@finect/tabular-utils/getFont';

export const QuestionFilters = styled.nav`
  display: flex;
  justify-content: space-between;

  ${maxMediaQueries.phablet`
    display: none;
  `};
`;

export const FilterSelectBlock = styled.div`
  display: none;
  position: relative;

  svg {
    position: absolute;
    top: 9px;
    right: 9px;
    pointer-events: none;
  }

  ${maxMediaQueries.phablet`
    display: block;
  `};
`;

export const FilterSelect = styled.select`
  display: none;
  width: 100%;
  padding: 6px 12px;
  border: 1px solid ${({ theme }) => theme.borderColor};
  border-radius: ${({ theme }) => theme.borderRadius};
  margin-bottom: 12px;
  background-color: #fff;
  ${getFont(0)};
  color: ${({ theme }) => theme.colors.font};

  ${maxMediaQueries.phablet`
    display: block;
  `};
`;
